import React from "react";
import { Outlet } from "react-router-dom";

const MainBody = () => {
  return <Outlet />;
};

export default MainBody;
